import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="h-screen overflow-y-auto bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 p-6 md:p-12 lg:py-24 flex justify-center">
      <div className="w-full max-w-4xl bg-white dark:bg-gray-800 rounded-3xl shadow-xl p-8 md:p-12 h-fit">
        <div className="mb-8 flex items-center justify-between">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">Privacy Policy</h1>
          <Link to="/signin" className="text-blue-600 dark:text-blue-400 hover:underline flex items-center font-medium">
            <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
            Back to Sign in
          </Link>
        </div>
        <div className="space-y-6 text-gray-700 dark:text-gray-300">
          <p className="font-semibold text-sm">Last Updated: January 07, 2022</p>

          <p>This Privacy Policy outlines our policies and procedures regarding the collection, use, and disclosure of your information when you use our Service. It also explains your privacy rights and how the law protects you.</p>

          <p>We use your personal data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Interpretation and Definitions</h3>
          <h4 className="font-medium text-gray-800 dark:text-gray-200">Interpretation</h4>
          <p>Words with an initial capital letter have specific meanings under the conditions described below. These definitions apply whether the terms appear in singular or plural form.</p>

          <h4 className="font-medium text-gray-800 dark:text-gray-200">Definitions</h4>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Account:</strong> A unique account created for you to access our Service or parts of our Service.</li>
            <li><strong>Company:</strong> Infinity Solution, 303, Emerald Complex, Chimanlal Girdharlal Rd, above Karnavati Pagarkha bazar, Mithakhali, Navrangpura, Ahmedabad, Gujarat 380009</li>
            <li><strong>Cookies:</strong> Small files placed on your device that store browsing history and other data.</li>
            <li><strong>Country:</strong> Gujarat, India.</li>
            <li><strong>Device:</strong> Any device that can access the Service such as a computer, cellphone, or tablet.</li>
            <li><strong>Personal Data:</strong> Information relating to an identified or identifiable individual.</li>
            <li><strong>Service:</strong> The website operated by Infinity Solution.</li>
            <li><strong>Service Provider:</strong> Any party processing data on behalf of the Company.</li>
            <li><strong>Usage Data:</strong> Data collected automatically from the Service or its infrastructure.</li>
            <li><strong>Website:</strong> Infinity Solution.</li>
            <li><strong>You:</strong> The individual using the Service, or a company or legal entity they represent.</li>
          </ul>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Collecting and Using Your Personal Data</h3>
          <h4 className="font-medium text-gray-800 dark:text-gray-200">Types of Data Collected</h4>
          <h5 className="font-medium">Personal Data</h5>
          <p>While using our Service, we may ask you to provide certain information, including but not limited to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Email address</li>
            <li>First and last name</li>
            <li>Phone number</li>
          </ul>

          <h5 className="font-medium">Usage Data</h5>
          <p>Usage Data is collected automatically and may include information such as your IP address, browser type and version, pages visited, time and date of visit, time spent on pages, device identifiers, and diagnostic data.</p>
          <p>When using a mobile device, we may also collect information such as device type, unique ID, IP address, operating system, mobile browser type, and other diagnostics.</p>

          <h4 className="font-medium text-gray-800 dark:text-gray-200">Tracking Technologies and Cookies</h4>
          <p>We use cookies, beacons, tags, and scripts to monitor and analyze Service activity.</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Necessary Cookies:</strong> Essential for providing website services.</li>
            <li><strong>Cookies Policy / Notice Acceptance Cookies:</strong> Store your consent preferences.</li>
            <li><strong>Functionality Cookies:</strong> Remember your preferences such as login details and language.</li>
          </ul>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Use of Your Personal Data</h3>
          <p>Your data may be used for the following purposes:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Providing and maintaining the Service</li>
            <li>Managing your account and registration</li>
            <li>Fulfilling contractual obligations</li>
            <li>Contacting you by email, phone, SMS, or other means</li>
            <li>Sending promotional information and offers</li>
            <li>Handling customer support and requests</li>
          </ul>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Retention of Data</h3>
          <p>We retain your personal data only as long as necessary to fulfill the purposes outlined in this policy or as required by law. Usage Data may be stored for shorter periods unless needed for security or service improvement.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Security of Data</h3>
          <p>We take reasonable measures to protect your personal data, but no transmission or storage method is 100% secure.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Children’s Privacy</h3>
          <p>Our Service is not intended for individuals under 13 years old. We do not knowingly collect data from children. If you believe your child has shared personal data with us, please contact us immediately.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Changes to This Privacy Policy</h3>
          <p>We may update this policy and will notify you of significant changes via email or a prominent notice on our website. Please review this page periodically for updates.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Contact Us</h3>
          <p>If you have any questions regarding this Privacy Policy, please contact us at:</p>
          <p>Email: mitul@infisms.com</p>
        </div>
      </div>
    </div>
  );
}
